<template>
    <div>
        <div v-if="hasHeadingLabel" class="form-group">
            <label>
                {{ headingLabel }}
                <input class="input__field" type="text" v-bind:name="fieldName + '[heading]'" v-model="heading">
            </label>
        </div>
        <div>
            <label class="m-b-2">{{ itemsLabel }}</label>
            <div v-sortable="{ handle: '.handle', sort: true, onUpdate: onUpdate }">
                <div v-for="(item, index) in items" v-bind:key="item.key" class="slat m-t-4 m-b-3">
                    <div class="br p-t-3 p-b-3">
                        <div class="slat-group-header slat-group-header-small row row-middle br-bottom p-b-3">
                            <div class="slat-controls slat-controls--mini m-vertical-none m-l-2">
                                <div class="i-container i-filled-dark m-b-2">
                                    <span class="handle">
                                        <!-- /icons/drag.svg -->
                                        <svg class="icon i-size-small inline icon-drag" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g transform="translate(8 3)" fill-rule="evenodd" class="icon"><rect width="3" height="3" rx="1.5"/><rect x="5" width="3" height="3" rx="1.5"/><rect y="5" width="3" height="3" rx="1.5"/><rect x="5" y="5" width="3" height="3" rx="1.5"/><rect y="10" width="3" height="3" rx="1.5"/><rect x="5" y="10" width="3" height="3" rx="1.5"/><rect y="15" width="3" height="3" rx="1.5"/><rect x="5" y="15" width="3" height="3" rx="1.5"/></g></svg>
                                    </span>
                                </div>
                            </div>
                            <div class="slat-content column p-l-2">
                                <h4 class="f-w-bold f-s-3 m-b-0">{{ trans('Bullet :id',  {'id': index + 1 }) }}</h4>
                            </div>
                            <div class="slat-aside text-right m-r-4">
                                <a class="btn btn-text width-auto-min" v-on:click.prevent="deleteItem(index)">
                                    <span class="i-container i-filled-dark">
                                        <!-- /icons/s-trash.svg -->
                                        <svg class="icon i-size-tiny inline" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="#6F6FFF" class="icon"><path d="M14.5 3.38h-3.512C10.923 1.782 9.613.5 8 .5S5.077 1.782 5.012 3.38H1.5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2zM8 2.5a.99.99 0 0 1 .976.88H7.024A.99.99 0 0 1 8 2.5zm5.499 3.507a1.01 1.01 0 0 0-1.104.884L11.604 14H4.396l-.79-7.109a1 1 0 0 0-1.989.22l.889 7.999A1 1 0 0 0 3.5 16h9a1 1 0 0 0 .994-.89l.889-7.999a1 1 0 0 0-.884-1.104z"/><path d="M7.5 11.5v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm3 0v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"/></g></svg>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="slat-group-content p-l-4 p-r-4 p-t-4 m-t-1">
                            <div class="form-group form-group-simple">
                                <rich-text-editor
                                    ref="bullet-text"
                                    v-bind:id="'bullet_text_' + index"
                                    v-bind:name="fieldName + '[items][' + index + '][text]'"
                                    height="100px"
                                    v-bind:content="item.text"
                                    v-bind:buttons="['bold', 'italic', 'underline', 'link' ]"
                                    v-bind:plugins="[]"
                                ></rich-text-editor>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center p-t-3">
            <button type="button" class="btn btn-text btn-text--accent btn-icon ul-none m-b-4" v-on:click="addItem(true)">
                <span class="icon i-container i-filled-accent">
                    <!-- /icons/add.svg -->
                    <svg class="icon i-size-small inline" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M11 5v14h2V5z"/><path d="M19 11H5v2h14z"/></g></svg>
                </span>
                {{ trans('Add Bullet') }}
            </button>
        </div>
    </div>
</template>
<script>
import Bullets from './Bullets.vue';
import DropdownMenu from '../DropdownMenu.vue';
import { EventBus } from '../../event-bus';

export default {
    components: {
        DropdownMenu
    },
    extends: Bullets,
    methods: {
        /**
         * Add item to the list of bullets.
         *
         * Extended in order to properly focus on the RTE.
         *
         * @param   {Boolean}  triggerFocus
         *
         * @return  {Void}
         */
        addItem(triggerFocus) {
            this.items.push({key: ++this.key, text: '', icon: this.defaultIcon, iconCode: this.getIcon(this.defaultIcon)});

            if (triggerFocus) {
                Vue.nextTick(() => {
                    this.$refs['bullet-text'][this.items.length - 1].editor.editor.endFocus();
                });
            }
        },
        /**
         * Delete bullet item from the list and trigger form check.
         *
         * @param   {Number}  index
         *
         * @return  {Void}
         */
        deleteItem(index) {
            this.items.splice(index, 1);

            Vue.nextTick(() => {
                EventBus.$emit('form:check');
            });
        },
    },
}
</script>